/** Drag distance that closes a sheet of unknown height. */
const FALLBACK_CLOSE_PX = 120;
/** Share of the sheet's height a downward drag must pass to close it. */
const CLOSE_SHARE = 0.25;
/** A downward flick faster than this closes the sheet… */
const FLICK_VELOCITY = 600;
/** …once it has moved at least this far. */
const FLICK_MIN_PX = 24;

/** Whether a bottom sheet released after a drag should close (offset and velocity are downward-positive). */
export function sheetShouldClose(offsetY: number, velocityY: number, height: number): boolean {
  if (offsetY <= 0) return false;
  const threshold = height > 0 ? height * CLOSE_SHARE : FALLBACK_CLOSE_PX;
  if (offsetY > threshold) return true;
  return velocityY > FLICK_VELOCITY && offsetY >= FLICK_MIN_PX;
}
